import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StringFormatPipe } from '../../pipe/string.format.pipe';

/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase CopyService, se utiliza para colocar información adicional al componente
 *
 * *Copy Service class definition, it's used to put aditional information in the component*
 *
 * @type {class}
 */
export class CopyService {

  /**
   * Definición de la variable copies como any
   *
   * *Copy Service variable definition as any*
   *
   * @type {any}
   */
  copies: any;

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @var {HttpClient} _http
   * @var {StringFormatPipe} stringFormat
   */
  constructor(
    private _http: HttpClient,
    private stringFormat: StringFormatPipe,
  ) {}

  /**
   * Función para cargar las copias que están guardadas en ./assets/resources/copies.json
   *
   * *Function to load copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} customURL
   */
  async loadCopies(customURL?: string) {
    let url;

    if (customURL === undefined) {
      url = './assets/resources/copies.json';
    } else {
      url = customURL;
    }

    await this._http.get(url).toPromise().then(response => {
      this.copies = response['data'].copies;
    });
  }

  /**
   * Función para obtener las copias que están guardadas en ./assets/resources/copies.json
   *
   * *Function to obtain copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} copyName
   * @returns {string}
   */
  getCopy(copyName: string): string {
    return this.copies[copyName];
  }

  /**
   * Función para obtener las copias parametrizadas que están guardadas en ./assets/resources/copies.json
   *
   * *Function to obtain parametrized copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} copyName
   * @returns {string}
   */
  getParametrizedCopy(copyName: string, parameters: string[], fatherCopyName?: string): string {
    const copy = fatherCopyName ? this.copies[fatherCopyName][copyName] : this.copies[copyName];
    return this.stringFormat.transform(copy, parameters);
  }
}
